import { FaRegEye } from "react-icons/fa";
import { twMerge } from "tailwind-merge";
import { INotification } from "../../../store/@types/notifications";
import { formatDateTime } from "../../../service/convert/date";

type INotificationAccordionItem = {
  notification: INotification;
  isExpanded: boolean;
  onToggle: () => void;
  onMarkAsSeen?: (notification: INotification) => void;
};

export const NotificationAccordionItem = ({
  notification,
  isExpanded,
  onToggle,
  onMarkAsSeen,
}: INotificationAccordionItem) => {
  const isNew = !notification.seen;

  const handleClick = () => {
    if (!isExpanded) {
      if (isNew && onMarkAsSeen) onMarkAsSeen(notification);
    }
    onToggle();
  };

  return (
    <div className="border-b border-gray-100/20">
      {/* Header */}
      <button
        onClick={handleClick}
        className="w-full flex items-center justify-between p-4 hover:bg-gray-50/20 transition"
      >
        <div className="flex flex-col text-left">
          <p
            className={`font-semibold ${
              isNew ? "text-primary-600" : "text-gray-800"
            }`}
          >
            {notification.subject}
          </p>

          <span className="text-xs text-gray-500">
            {formatDateTime(notification.created_at)}
          </span>
        </div>

        {/* Seen Icon */}
        <span
          className={twMerge(
            "flex items-center px-2 py-1 rounded-full text-xs font-normal",
          )}
        >
          <FaRegEye className={isNew ? "text-red-500" : "text-primary-500"} />
        </span>
      </button>

      {/* Body */}
      <div
        className={twMerge(
          "overflow-hidden transition-all duration-300",
          isExpanded ? "max-h-[1000px] p-4" : "max-h-0 p-0",
        )}
      >
        <div
          className="prose prose-sm max-w-none text-gray-800 text-left"
          dangerouslySetInnerHTML={{
            __html: notification.message || "",
          }}
        />
      </div>
    </div>
  );
};
